import { SALES_DEMO_ACCOUNT_ID } from "../constants/Constants";

/**
 * このファイルにはuser元に共通処理をする関数を定義しています。
 * TODO utils/utils.jsにユーザー関連が多くあるので、本ファイルに移行する
 */
import moment from "moment";

/**
 * 1通送付できるかどうかを判定
 * @param  {object} user ユーザー
 * @return {bool} true: 可能, false: 不可
 */
export const isSendOneLetter = (user) => {
  return user && (user.min_letter_order_count === null || user.min_letter_order_count === 1);
}

/**
 * プランが有効期限内かどうかを判定
 * @param {object} user
 * @return {bool} true: 可能, false: 不可
 */
export const isPlanExpired = (user) => {
  if (!user) return false;

  // if current_plan_expiration_at is null, then there is no active plan
  // therefore expiration_at should be before today
  const expiration_at = user && user.current_plan_expiration_at
    ? moment(user.current_plan_expiration_at)
    : moment("2000-01-01");
  const now = moment();

  return expiration_at.isBefore(now)
}

/**
 * 法人番号でキーマンデータベースを検索できるかどうかを判定
 * @param user ユーザー
 * @return {bool} true: 利用可, false: 利用不可
 */
export const isEnableSearchExeByCorpNumbers = (user) => {
  return user && user.active_plan && user.active_plan.search_exe_by_corp_numbers_flag;
}

/**
 * 部門電話番号が表示できるかどうかを判定
 * @param user ユーザー
 * @return {bool} true: 利用可, false: 利用不可
 */
export const isEnableDisplayDepartmentTel = (user) => {
  return user && user.can_display_department_tel;
}

/**
 * KLにフォローコールを委託するかどうかを判定
 * @param user ユーザー
 * @return {bool} true: 利用可, false: 利用不可
 */
export const isKLFollowCall = (user) => {
  // DBにある「BDR自社運用」のプランはKLでフォローコールを行わないプランのため、除外しつつ
  // BDRの文言が含まれているプランがあるかを判定
  return user && user.active_plan && user.active_plan.name.includes("BDR") && !user.active_plan.name.includes("自社運用");
}

/**
 * KLにフォローコールを委託していたかどうかを判定
 * @param user ユーザー
 * @return {bool}
 */
export const hasKLFollowCallBeenEnabled = (user) => {
  // 現在のプランがKLでフォローコールを行うプランであればtrueを返す
  if (isKLFollowCall(user)) {
    return true;
  }

  return user && user.plans && user.plans.some(plan => {
    // DBにある「BDR自社運用」のプランはKLでフォローコールを行わないプランのため、除外しつつ
    // BDRの文言が含まれているプランがあるかを判定
    return plan.name.includes("BDR") && !plan.name.includes("自社運用");
  });
}

/**
 * 1注文ごとにレター送付の料金が発生するかどうかを判定
 * @param user ユーザー
 * @return {bool}
 */
export const isLetterCostPerOrder = (user) => {
  // プラン名に「BDR」も「自社運用」も含まないプランは、1通づつ送付で課金されるプランとみなす。
  return user && user.active_plan && (!user.active_plan.name.includes("BDR") && !user.active_plan.name.includes("自社運用"));
}

/**
 * リアクションキーワード検索が有効かどうかを判定
 * @param user ユーザー
 * @return {bool}
 */
export const isEnableReactionKeyword = (user) => {
  return user && user.recommend_flag; // DBのrecommend_flagが1の場合、リアクションキーワード検索が有効。もともとレコメンド機能があった時代の名残りで、現在はリアクションキーワード検索は独立している。
}

/**
 * 営業デモかどうか
 * @param user ユーザー
 * @return {bool}
 */
export const isSalesDemo = (user) => {
  return user && user.id === SALES_DEMO_ACCOUNT_ID && process.env.REACT_APP_BUILD_ENV === 'production';
}

/**
 * 注文したレターが存在するかどうかを判定
 * @param user ユーザー
 * @return {bool}
 */
export const isHasLetterOrders = (user) => {
  return user && user.has_letter_orders;
}



// WEBPACK FOOTER //
// ./src/utils/userUtils.js